<template>
  <OptionsMenuModal modal-id="map-options-dialog" :title="$t('map_options_dialog.options')">
    <OptionsMenuSection
      v-for="section in items.sections"
      :key="section.key"
      :title="optionsSectionTitle(section.key)"
    >
      <OptionsMenuTile
        v-for="item in section.items"
        :key="item.event"
        :icon="item.icon"
        :label="$t(item.labelKey)"
        :pro="!!item.pro"
        :tag="item.isNew ? $t('map_options_dialog.new_tag') : ''"
        @select="emitAndClose(item.event)"
      />
    </OptionsMenuSection>
    <template v-if="items.footer" #footer>
      <OptionsMenuFooterLink
        :icon="items.footer.icon"
        :label="$t(items.footer.labelKey)"
        @select="emitAndClose(items.footer.event)"
      />
    </template>
  </OptionsMenuModal>
</template>

<script setup>
import { computed } from 'vue'
import { Modal } from 'bootstrap'
import OptionsMenuModal from '../components/options_menu/OptionsMenuModal.vue'
import OptionsMenuSection from '../components/options_menu/OptionsMenuSection.vue'
import OptionsMenuTile from '../components/options_menu/OptionsMenuTile.vue'
import OptionsMenuFooterLink from '../components/options_menu/OptionsMenuFooterLink.vue'
import { mapOptionsItems } from './mapOptionsItems'
import { optionsSectionTitle } from '../components/options_menu/optionsSections'

// Define props to control which options are visible
const props = defineProps({
  showEditDetails: {
    type: Boolean,
    default: false
  },
  editHike: {
    type: Boolean,
    default: true
  },
  showCreate: {
    type: Boolean,
    default: true
  },
  showWaypoints: {
    type: Boolean,
    default: true
  },
  showGoTo: {
    type: Boolean,
    default: true
  },
  showFlyover: {
    type: Boolean,
    default: false
  },
  showMeasurement: {
    type: Boolean,
    default: true
  },
  showPrint: {
    type: Boolean,
    default: true
  },
  showReportIssue: {
    type: Boolean,
    default: false
  },
  // Off by default: only pages that mount #download_modal / #embed-builder-app can open them.
  showDownload: {
    type: Boolean,
    default: false
  },
  showEmbed: {
    type: Boolean,
    default: false
  }
})

const items = computed(() => mapOptionsItems(props))

const emit = defineEmits(['edit-details','edit','create','reverse','waypoints','goto','flyover','measurement','print','report-issue','download','embed'])

function emitAndClose(evt){
  const el = document.getElementById('map-options-dialog');
  if (el) Modal.getOrCreateInstance(el).hide();
  emit(evt)
}

function open(){
  const el = document.getElementById('map-options-dialog');
  if (el) Modal.getOrCreateInstance(el).show();
}
defineExpose({ open })
</script>
